// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#Edit{
    padding-top: 100px;
}
#Edit .flexColumn {
    min-height: 100vh;
    /* width: 70vw; */
    align-items: flex-start !important;
    padding-top: 50px;
}
#EditUserDropdownContainer {
    width: 100%;
    position: fixed;
    top: 0;
    right: 0;
    display: flex;
    justify-content: flex-end;
    padding: 10px;
}
#Edit .titleText {
    margin-left: 0;
}
#Upload {
    padding: 20px 0;
    padding-top: calc(75px + 20px);
    align-items: flex-start;
}

#EditLayout {
    align-items: flex-start !important;
}

#EditLayout h1 {
    margin-left: 0;
}

#EditLayout input,
#EditLayout textarea {
    width: 500px;
}

#EditLayout > * {
    margin: 5px 0;
}`, "",{"version":3,"sources":["webpack://./src/Magor/RecordingsManager/edit.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kCAAkC;IAClC,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,eAAe;IACf,MAAM;IACN,QAAQ;IACR,aAAa;IACb,yBAAyB;IACzB,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB","sourcesContent":["#Edit{\n    padding-top: 100px;\n}\n#Edit .flexColumn {\n    min-height: 100vh;\n    /* width: 70vw; */\n    align-items: flex-start !important;\n    padding-top: 50px;\n}\n#EditUserDropdownContainer {\n    width: 100%;\n    position: fixed;\n    top: 0;\n    right: 0;\n    display: flex;\n    justify-content: flex-end;\n    padding: 10px;\n}\n#Edit .titleText {\n    margin-left: 0;\n}\n#Upload {\n    padding: 20px 0;\n    padding-top: calc(75px + 20px);\n    align-items: flex-start;\n}\n\n#EditLayout {\n    align-items: flex-start !important;\n}\n\n#EditLayout h1 {\n    margin-left: 0;\n}\n\n#EditLayout input,\n#EditLayout textarea {\n    width: 500px;\n}\n\n#EditLayout > * {\n    margin: 5px 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
